import { Select } from '@zoopla-eng/zds/select';
import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    dropdownWrapperStyle,
    filtersLabelStyle,
    filterWrapperStyle,
    leftWrapperStyle,
    rightWrapperStyle
} from './Options.styles.css';

const beds = ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const bedsOptions = [
    { value: '0', text: 'Studio' },
    { value: '1', text: '1' },
    { value: '2', text: '2' },
    { value: '3', text: '3' },
    { value: '4', text: '4' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '7', text: '7' },
    { value: '8', text: '8' },
    { value: '9', text: '9' },
    { value: '10', text: '10+' }
];

export type BedsMin = typeof beds[number];
export type BedsMax = typeof beds[number];

type SelectBedsProps = {
    value: {
        bedsMin: BedsMin;
        bedsMax: BedsMax;
    };
    onChange: ({
        bedsMin,
        bedsMax
    }: {
        bedsMin: BedsMin;
        bedsMax: BedsMax;
    }) => void;
};

export const SelectBeds = ({ value, onChange }: SelectBedsProps) => {
    const bedroomsLabel = 'Bedrooms';
    const minBedsLabel = 'Min beds';
    const maxBedsLabel = 'Max beds';

    const bedsMinOptions =
        value.bedsMax !== ''
            ? bedsOptions.slice(0, Number(value.bedsMax) + 1)
            : bedsOptions;

    const bedsMaxOptions =
        value.bedsMin !== ''
            ? bedsOptions.slice(Number(value.bedsMin))
            : bedsOptions;

    const minBedOptions = bedsMinOptions.map((bedsMinOption, index) => ({
        id: bedsMinOption.value,
        text: bedsMinOption.text
    }));

    const maxBedOptions = bedsMaxOptions.map((bedsMaxOption, index) => ({
        id: bedsMaxOption.value,
        text: bedsMaxOption.text
    }));

    const minDefaultOption = {
        id: '',
        text: 'No min'
    };

    const maxDefaultOption = {
        id: '',
        text: 'No max'
    };

    return (
        <div className={filterWrapperStyle}>
            <label
                className={`${filtersLabelStyle} ${fontGroups.ladle}`}
                htmlFor="modal-beds-filter"
            >
                {bedroomsLabel}
            </label>
            <div className={dropdownWrapperStyle}>
                <div className={leftWrapperStyle}>
                    <Select
                        // TODO: fix e2e tests
                        data-testid="min_beds_mobile"
                        options={[minDefaultOption, ...minBedOptions]}
                        onSelectedOptionChange={({ id }) => {
                            onChange({
                                ...value,
                                bedsMin: id
                            });
                        }}
                        selectedOption={
                            minBedOptions.find((o) => o.id === value.bedsMin) ??
                            minDefaultOption
                        }
                        label={minBedsLabel}
                    />
                </div>
                <div className={rightWrapperStyle}>
                    <Select
                        options={[maxDefaultOption, ...maxBedOptions]}
                        onSelectedOptionChange={({ id }) => {
                            onChange({
                                ...value,
                                bedsMax: id
                            });
                        }}
                        selectedOption={
                            maxBedOptions.find((o) => o.id === value.bedsMax) ??
                            maxDefaultOption
                        }
                        label={maxBedsLabel}
                    />
                </div>
            </div>
        </div>
    );
};
